module.exports = __webpack_public_path__ + "static/rfrk-logo-a9680cee28fe9a5b99aef8720fe4049c.png";